import { render, staticRenderFns } from "./SupplierShipment.vue?vue&type=template&id=92c153cc&"
import script from "./SupplierShipment.vue?vue&type=script&lang=js&"
export * from "./SupplierShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports